export default "__VITE_ASSET__3ZQVWAU9__"